import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const PorcentajeFormGroup = ({ index }) => {
  return (
    <Form.Group>
      <Col md={12}>
        <Field name='porcentaje'>
          {({ field }) => <Form.InputText {...field} id={`input-sustraccion-porcentaje-${index}`} disabled />}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(PorcentajeFormGroup)
